<template>
  <div id="app-div">
    <div id="load_screen" v-if="loading">
      <div class="loader">
        <div class="loader-content">
<!--            add loader svg here-->
        </div>
      </div>
    </div>
    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      loading: true,
      loaded: false,
      sessionStartTime: null,
      sessionId: null,
      userId: null,
    };
  },
  created() {
    const url = new URL(window.location);
    const impersonateToken = url.searchParams.get('impersonateToken');
    if (impersonateToken) {
      this.impersonate(impersonateToken);
    }else {
      this.getUser();
    }
  },
  mounted() {
    this.sessionStartTime = Date.now();
    this.sessionId = this.generateSessionId();

    window.addEventListener('beforeunload', this.sendSessionDuration);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    this.stopTrackingAndSendEvent();
    window.removeEventListener('beforeunload', this.sendSessionDuration);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    getUser() {
      this.$store.commit('setUserLoading', true);
      this.$http.get('/auth/profile', {
        noAlert: true,
      })
        .then((res) => {
          this.$store.commit('setUser', res.body.data);
          this.$store.commit('setImpersonation', this.$auth.getImpersonation());
          this.userId = res.body.data.id;
          this.$auth.setRole('caregiver');
          this.$acl.change('caregiver');
          if (res.body.data.roles.length > 0) {
            this.$role.setPermissions(res.body.data.roles[0].name, res.body.data.roles[0].permissions.map((permission) => permission.name));
          }
          this.loading = false;
          this.loaded = true;
          this.$store.commit('setUserLoading', false);
        })
        .catch(function () {
          this.loading = false;
          this.loaded = true;
          this.$store.commit('setUserLoading', false);
        });
    },
    impersonate: function (token) {
      if (!token) {
        return;
      }
      this.$store.commit('setUserLoading', true);
      this.loading = true;
      this.$http.post("/auth/impersonate", {
        token: token
      })
        .then((res) => {
          this.loading = false;
          if (res.body.data.token) {
            this.$store.commit('setUser', res.body.data.user);
            this.$store.commit('setImpersonation', true);
            this.$auth.setToken(res.body.data.token);
            this.$auth.setImpersonation(true);
            this.$auth.setRole('caregiver');
            this.$acl.change('caregiver');
            this.$router.push({name: 'home'});
            this.loading = false;
            this.loaded = true;
            this.$store.commit('setUserLoading', false);
          }
        })
        .catch((error) => {
          console.log(error)
          this.loading = false;
          this.loaded = true;
          this.$store.commit('setUserLoading', false);
        });
    },
    stopTrackingAndSendEvent() {
      const endTime = Date.now();
      const duration = Math.round((Date.now() - this.trackingStartTime) / 1000);
      this.$gtag.event('session_duration', {
        tracked_user_id: this.user.uid,
        time_spent: duration
      });
    },
    generateSessionId() {
      return 'sess-' + Math.random().toString(36).substr(2, 9);
    },
    sendSessionDuration() {
      const endTime = Date.now();
      const durationSeconds = Math.round((endTime - this.sessionStartTime) / 1000);

      const payload = {
        event: 'session_duration',
        session_id: this.sessionId,
        duration_seconds: durationSeconds,
        tracked_user_id: this.user.uid,
      };

      const blob = new Blob([JSON.stringify(payload)], {
        type: 'application/json',
      });

      navigator.sendBeacon('https://api.magnusmode.com/api/caregiver/analytics/track-event', blob);
    }
  },
};
</script>
